<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  <div i18n="@@challengeDetails">Challenge Details</div>
  <mat-icon (click)="closeDialog()" class="cursor" i18n-label="@@closeDialogIcon" aria-label="Close">close</mat-icon>
</div>
<mat-dialog-content>
  <mat-card class="mb-16">
    <mat-card-content>
      <div class="d-flex mb-12">
        <mat-icon class="mr-10" color="accent" i18n-label="@@bulletPointIcon" aria-label="Bullet point">fiber_manual_record</mat-icon>
        <div i18n="@@competitorChallenge" class="mat-subtitle-1" matTooltip ellipsisTooltip>What is the competitor's challenge</div>
      </div>
      <div class="mat-caption" matTooltip ellipsisTooltip>{{challenge?.competitorChallenge}}</div>
    </mat-card-content>
  </mat-card>

  <mat-card class="mb-16">
    <mat-card-content>
      <div class="d-flex mb-12">
        <mat-icon class="mr-10" color="accent" i18n-label="@@bulletPointIcon" aria-label="Bullet point">fiber_manual_record</mat-icon>
        <div i18n="@@whatProductOffers" class="mat-subtitle-1" matTooltip ellipsisTooltip>What does our product offer</div>
      </div>
      <div class="mat-caption" matTooltip ellipsisTooltip>{{challenge?.productOffer}}</div>
    </mat-card-content>
  </mat-card>

  <mat-card class="mb-16">
    <mat-card-content>
      <div class="d-flex mb-12">
        <mat-icon class="mr-10" color="accent" i18n-label="@@bulletPointIcon" aria-label="Bullet point">fiber_manual_record</mat-icon>
        <div i18n="@@productValue" class="mat-subtitle-1" matTooltip ellipsisTooltip>Product value</div>
      </div>
      <div class="mat-caption" matTooltip ellipsisTooltip>{{challenge?.productValue}}</div>
    </mat-card-content>
  </mat-card>

  <mat-card class="mb-16">
    <mat-card-content>
      <div class="d-flex mb-12">
        <mat-icon class="mr-10" color="accent" i18n-label="@@supportMaterialsIcon" aria-label="Support materials icon">insert_drive_file</mat-icon>
        <div i18n="@@supportMaterials" class="mat-subtitle-1" matTooltip ellipsisTooltip>Support materials</div>
      </div>

      @for (material of challenge.supportMaterial ; track material; let index = $index) {
        <div class="mat-caption d-flex justify-content-between mb-10">
          @if (material.type === utils.supportMaterials.Link) {
            <span matTooltip ellipsisTooltip>{{truncate(material.path)}}</span>
          }
          @if (material.type !== utils.supportMaterials.Link) {
            <span matTooltip ellipsisTooltip>{{truncate(material.name)}}</span>
          }
          <a (click)="downloadMyFileAndLog(material)" href="{{material.path}}" target="_blank" i18n-label="@@downloadMaterialIcon" aria-label="Download material">
            <mat-icon color="accent" class="cursor">get_app</mat-icon>
          </a>
        </div>
      }
    </mat-card-content>
  </mat-card>
  <!-- <mat-card *ngIf="authService.getUserData().type === utils.userTypes.Distributor" class="used-on-mobile">
    <div i18n="@@usedOnMobile" class="mat-subheading-2">Use on mobile</div>
    <mat-checkbox data-testid="used_on_mobile_check" (change)="usedOnMobileToggle($event)" color="accent" i18n-label="@@usedOnMobileCheck" aria-label="Use on mobile checkbox"></mat-checkbox>
  </mat-card> -->
</mat-dialog-content>